import { Button } from "@/components/ui/button";
import type { NextStep, NextStepId } from "./drawerLogic";

interface NextStepBoxProps {
  step: NextStep;
  onAction: (id: NextStepId) => void;
  /** Buttons whose action is running. */
  busy?: Partial<Record<NextStepId, boolean>>;
}

/** The Next step box under the event strip: resolveNextStep()'s message and buttons (#1559). */
export function NextStepBox({ step, onAction, busy = {} }: NextStepBoxProps) {
  return (
    <div
      data-next-step
      className="flex flex-wrap items-center justify-between gap-x-3.5 gap-y-2 rounded-[9px] bg-accent-soft px-3 py-2.5"
    >
      <div className="min-w-0">
        <span className="block text-[11px] font-bold uppercase tracking-[.08em] text-accent">Next step</span>
        <span className="text-[13.5px]">
          {step.parts.map((p, i) =>
            p.tone === "strong" ? (
              <b key={i}>{p.text}</b>
            ) : p.tone === "hot" ? (
              <span key={i} className="font-bold text-status-hot">{p.text}</span>
            ) : p.tone === "quote" ? (
              <span key={i} className="mt-1 block rounded-md border-l-[3px] border-accent bg-card px-2.5 py-1.5 italic">
                "{p.text}"
              </span>
            ) : (
              <span key={i}>{p.text}</span>
            ),
          )}
        </span>
      </div>
      {step.buttons.length > 0 && (
        <div className="grid gap-1">
          <div className="flex flex-wrap gap-2">
            {step.buttons.map((b) => (
              <Button
                key={b.id}
                type="button"
                size="sm"
                variant={b.primary ? "default" : "outline"}
                className={b.primary ? undefined : "bg-card"}
                disabled={b.disabled || busy[b.id]}
                onClick={() => onAction(b.id)}
              >
                {b.label}
              </Button>
            ))}
          </div>
          {step.blockedNote && <span className="text-[12px] text-muted-foreground">{step.blockedNote}</span>}
        </div>
      )}
    </div>
  );
}
